// Components, Layouts, Pages
import {
  CrmCommonPage,
  JobsCommonPage,
  LeadCommonPage,
  TaskCommonPage,
  UserCommonPage,
  VenueCommonPage,
  OrderCommonPage,
  QuotesCommonPage,
  TrucksCommonPage,
  ClientCommonPage,
  GlobalCommonPage,
  ReportsCommonPage,
  TrailerCommonPage,
  PackageCommonPage,
  InvoiceCommonPage,
  VendorsCommonPage,
  CouponsCommonPage,
  ScheduleCommonPage,
  SettingsCommonPage,
  CategoryCommonPage,
  UserFormCommonPage,
  VehiclesCommonPage,
  DashboardCommonPage,
  EquipmentCommonPage,
  InventoryCommonPage,
  EventTypeCommonPage,
  RoleFormCommonPage,
  VenueFormCommonPage,
  OrderFormCommonPage,
  ChecklistCommonPage,
  JobDetailCommonPage,
  QuarantineCommonPage,
  QuotesFormCommonPage,
  UserDetailCommonPage,
  ClientFormCommonPage,
  InventoriesCommonPage,
  PackageFormCommonPage,
  VenueDetailCommonPage,
  InvoiceFormCommonPage,
  ClientDetailCommonPage,
  QuotesDetailCommonPage,
  OrderDetailsCommonPage,
  PurchaseOrderCommonPage,
  InventoryFormCommonPage,
  RevenueReportCommonPage,
  DeliveryReportCommonPage,
  TaskCompletionCommonPage,
  VendorsDetailsCommonPage,
  RoleManagementCommonPage,
  InventoryDetailCommonPage,
  JobCostingReportCommonPage,
  QuarantineReportCommonPage,
  QuoteRevenueReportCommonPage,
  OrderRevenueReportCommonPage,
  CancellationReportCommonPage,
  ClientIncomeReportCommonPage,
  FeatureUtilizationCommonPage,
  ReportsForemanTaskCommonPage,
  DiscountUsageReportCommonPage,
  PurchaseOrderDetailsCommonPage,
  ReportsFinancialOrderCommonPage,
  ReportsInventoryUsageCommonPage,
  ReportsOverbookingItemCommonPage,
  ReportsMarketingRevenueCommonPage,
  GeographicRevenueReportCommonPage,
  ReportsSubrentalsReportCommonPage,
  ReportsTransactionSummaryCommonPage,
} from '~/pages/common';
// Others
import { MenuNameEnum } from '~/utils/enum/common';
import { IRouteModel } from '~/utils/interface/base';
import { loaderRoute, loaderRouteAbsolute } from '../roleRoutes/loader';
// Styles, images, icons
import { icons } from '~/assets';

export const privateLoaderRoutes: IRouteModel[] = [
  // Dashboard
  {
    index: true,
    path: loaderRoute.base,
    component: DashboardCommonPage,
    name: MenuNameEnum.DASHBOARD,
    icon: icons.menuIconDashboardUnactive,
    activeIcon: icons.menuIconDashboardActive,
  },

  // Global
  {
    path: loaderRouteAbsolute.global,
    component: GlobalCommonPage,
  },

  // CRM
  {
    path: loaderRouteAbsolute.crm,
    component: CrmCommonPage,
    name: MenuNameEnum.CRM,
    icon: icons.menuIconCrmUnactive,
    activeIcon: icons.menuIconCrmActive,
    children: [
      {
        path: loaderRouteAbsolute.leads,
        component: LeadCommonPage,
        name: MenuNameEnum.LEADS,
      },
      {
        path: loaderRouteAbsolute.clients,
        component: ClientCommonPage,
        name: MenuNameEnum.CLIENT,
      },
    ],
  },
  {
    path: loaderRouteAbsolute.createLead,
    component: ClientFormCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.crm}${loaderRoute.leads}${loaderRoute.commonDetail}${loaderRoute.commonEdit}`,
    component: ClientFormCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.crm}${loaderRoute.leads}${loaderRoute.commonDetail}`,
    component: ClientDetailCommonPage,
  },
  {
    path: loaderRouteAbsolute.createClient,
    component: ClientFormCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.crm}${loaderRoute.clients}${loaderRoute.commonDetail}${loaderRoute.commonEdit}`,
    component: ClientFormCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.crm}${loaderRoute.clients}${loaderRoute.commonDetail}`,
    component: ClientDetailCommonPage,
  },

  // Schedule
  {
    path: loaderRouteAbsolute.schedule,
    component: ScheduleCommonPage,
    name: MenuNameEnum.SCHEDULE,
    icon: icons.menuIconScheduleUnactive,
    activeIcon: icons.menuIconScheduleActive,
  },

  // Jobs
  {
    path: loaderRouteAbsolute.jobs,
    component: JobsCommonPage,
    name: MenuNameEnum.JOBS,
    icon: icons.menuIconJobsUnactive,
    activeIcon: icons.menuIconJobsActive,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.jobs}${loaderRoute.commonDetail}`,
    component: JobDetailCommonPage,
  },

  // Task
  {
    path: loaderRouteAbsolute.task,
    name: MenuNameEnum.TASKS,
    icon: icons.menuIconTaskInActive,
    activeIcon: icons.menuIconTaskActive,
    component: TaskCommonPage,
  },

  // Communication
  // {
  //   path: loaderRouteAbsolute.communication,
  //   component: CommunicationCommonPage,
  //   name: MenuNameEnum.COMMUNICATION,
  //   icon: icons.menuIconCommunicationUnactive,
  //   activeIcon: icons.menuIconCommunicationActive,
  // },

  // Quotes
  {
    path: loaderRouteAbsolute.quotes,
    component: QuotesCommonPage,
    name: MenuNameEnum.QUOTES,
    icon: icons.menuIconQuotesUnactive,
    activeIcon: icons.menuIconQuotesActive,
  },
  {
    path: loaderRouteAbsolute.createQuotes,
    component: QuotesFormCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.quotes}${loaderRoute.commonDetail}${loaderRoute.commonEdit}`,
    component: QuotesFormCommonPage,
  },

  //  Order
  {
    path: loaderRouteAbsolute.order,
    component: OrderCommonPage,
    name: MenuNameEnum.ORDER,
    icon: icons.menuIconOrderInactive,
    activeIcon: icons.menuIconOrderActive,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.order}${loaderRoute.commonDetail}`,
    component: OrderDetailsCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.order}${loaderRoute.commonDetail}${loaderRoute.commonEdit}`,
    component: OrderFormCommonPage,
  },

  // Invoice
  {
    path: loaderRouteAbsolute.invoices,
    component: InvoiceCommonPage,
    name: MenuNameEnum.INVOICE,
    icon: icons.menuIconInvoiceInactive,
    activeIcon: icons.menuIconInvoiceActive,
  },
  {
    path: loaderRouteAbsolute.createInvoice,
    component: InvoiceFormCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.invoice}${loaderRoute.commonDetail}${loaderRoute.commonEdit}`,
    component: InvoiceFormCommonPage,
  },

  // Inventories
  {
    path: `${loaderRoute.base}${loaderRoute.quotes}${loaderRoute.commonDetail}`,
    component: QuotesDetailCommonPage,
  },
  {
    path: loaderRouteAbsolute.inventories,
    component: InventoriesCommonPage,
    name: MenuNameEnum.INVENTORY,
    icon: icons.menuIconInventoryInactive,
    activeIcon: icons.menuIconInventoryActive,
    children: [
      {
        path: loaderRouteAbsolute.inventory,
        component: InventoryCommonPage,
        name: MenuNameEnum.PRODUCT,
      },
      {
        path: loaderRouteAbsolute.package,
        component: PackageCommonPage,
        name: MenuNameEnum.PACKAGE,
      },
      {
        path: loaderRouteAbsolute.quarantine,
        component: QuarantineCommonPage,
        name: MenuNameEnum.QUARANTINE,
      },
    ],
  },
  {
    path: loaderRouteAbsolute.createInventory,
    component: InventoryFormCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.inventory}${loaderRoute.product}${loaderRoute.commonDetail}`,
    component: InventoryDetailCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.inventory}${loaderRoute.product}${loaderRoute.commonDetail}${loaderRoute.commonEdit}`,
    component: InventoryFormCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.inventory}${loaderRoute.package}${loaderRoute.commonDetail}${loaderRoute.commonEdit}`,
    component: PackageFormCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.inventory}${loaderRoute.package}${loaderRoute.commonDetail}${loaderRoute.commonClone}`,
    component: PackageFormCommonPage,
  },

  // Report
  {
    path: `${loaderRoute.base}${loaderRoute.reports}`,
    component: ReportsCommonPage,
    name: MenuNameEnum.REPORTS,
    icon: icons.menuIconReportUnactive,
    activeIcon: icons.menuIconReportActive,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.overbookingItem}`,
    component: ReportsOverbookingItemCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.subrentalsReport}`,
    component: ReportsSubrentalsReportCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.clientIncomeReport}`,
    component: ClientIncomeReportCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.revenueReport}`,
    component: RevenueReportCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.geographicRevenueReport}`,
    component: GeographicRevenueReportCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.quoteRevenueReport}`,
    component: QuoteRevenueReportCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.orderRevenueReport}`,
    component: OrderRevenueReportCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.cancellationReport}`,
    component: CancellationReportCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.deliveryReport}`,
    component: DeliveryReportCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.taskCompletionReport}`,
    component: TaskCompletionCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.discountUsageReport}`,
    component: DiscountUsageReportCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.featureUtilizationReport}`,
    component: FeatureUtilizationCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.jobCostingReport}`,
    component: JobCostingReportCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.inventoryUsageReport}`,
    component: ReportsInventoryUsageCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.quarantineReport}`,
    component: QuarantineReportCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.foremanTaskReport}`,
    component: ReportsForemanTaskCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.marketingRevenueReport}`,
    component: ReportsMarketingRevenueCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.financialOrderReport}`,
    component: ReportsFinancialOrderCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.reports}${loaderRoute.transactionSummaryReport}`,
    component: ReportsTransactionSummaryCommonPage,
  },

  // Package
  {
    path: loaderRouteAbsolute.createPackage,
    component: PackageFormCommonPage,
  },

  {
    path: loaderRouteAbsolute.vehicles,
    component: VehiclesCommonPage,
    name: MenuNameEnum.VEHICLES,
    icon: icons.menuIconVehicleInactive,
    activeIcon: icons.menuIconVehicleActive,
    children: [
      {
        path: loaderRouteAbsolute.trucks,
        component: TrucksCommonPage,
        name: MenuNameEnum.TRUCKS,
        icon: icons.menuIconTruckInActive,
        activeIcon: icons.menuIconTruckActive,
      },
      {
        path: loaderRouteAbsolute.trailers,
        component: TrailerCommonPage,
        name: MenuNameEnum.TRAILERS,
        icon: icons.menuIconTrailerInActive,
        activeIcon: icons.menuIconTrailerActive,
      },
      {
        path: loaderRouteAbsolute.equipments,
        component: EquipmentCommonPage,
        name: MenuNameEnum.EQUIPMENTS,
        icon: icons.menuIconEquipmentInActive,
        activeIcon: icons.menuIconEquipmentActive,
      },
    ],
  },

  // Vendors
  {
    path: loaderRouteAbsolute.vendors,
    component: VendorsCommonPage,
    name: MenuNameEnum.VENDORS,
    icon: icons.menuIconVendorsInactive,
    activeIcon: icons.menuIconVendorsActive,
  },
  {
    path: loaderRouteAbsolute.detailVendor,
    component: VendorsDetailsCommonPage,
  },

  // Purchase Order
  {
    path: loaderRouteAbsolute.purchaseOrder,
    component: PurchaseOrderCommonPage,
    name: MenuNameEnum.PURCHASE_ORDER,
    icon: icons.menuIconPurchaseInactive,
    activeIcon: icons.menuIconPurchaseActive,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.purchaseOrder}${loaderRoute.commonDetail}`,
    component: PurchaseOrderDetailsCommonPage,
  },

  // Settings
  {
    path: loaderRouteAbsolute.settings,
    component: SettingsCommonPage,
    name: MenuNameEnum.SETTINGS,
    icon: icons.menuIconSettingUnactive,
    activeIcon: icons.menuIconSettingActive,
  },

  // User
  {
    path: loaderRouteAbsolute.users,
    component: UserCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.settings}${loaderRoute.users}${loaderRoute.commonDetail}`,
    component: UserDetailCommonPage,
  },
  {
    path: loaderRouteAbsolute.createUser,
    component: UserFormCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.settings}${loaderRoute.users}${loaderRoute.commonDetail}${loaderRoute.commonEdit}`,
    component: UserFormCommonPage,
  },

  // Venue
  {
    path: loaderRouteAbsolute.venue,
    component: VenueCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.settings}${loaderRoute.venue}${loaderRoute.commonDetail}`,
    component: VenueDetailCommonPage,
  },
  {
    path: loaderRouteAbsolute.createVenue,
    component: VenueFormCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.settings}${loaderRoute.venue}${loaderRoute.commonDetail}${loaderRoute.commonEdit}`,
    component: VenueFormCommonPage,
  },

  // Role Management
  {
    path: loaderRouteAbsolute.roleManagement,
    component: RoleManagementCommonPage,
  },
  {
    path: loaderRouteAbsolute.createRole,
    component: RoleFormCommonPage,
  },
  {
    path: `${loaderRoute.base}${loaderRoute.settings}${loaderRoute.roleManagement}${loaderRoute.commonDetail}${loaderRoute.commonEdit}`,
    component: RoleFormCommonPage,
  },

  // Coupon
  {
    path: loaderRouteAbsolute.coupon,
    component: CouponsCommonPage,
  },

  // Event Type
  {
    path: loaderRouteAbsolute.eventType,
    component: EventTypeCommonPage,
  },

  // Category
  {
    path: loaderRouteAbsolute.category,
    component: CategoryCommonPage,
  },

  // Checklist
  {
    path: loaderRouteAbsolute.checklist,
    component: ChecklistCommonPage,
  },
];
